import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "@/store/GlobalStore";
import { PictureLever } from "project-config/constants/user-info";
import {
  BalanceText,
  BalanceTextContent,
  LevelCard,
  MemberSystemWrapper,
  Privilege,
  PrivilegeContent,
  PrivilegeTitle,
  UserName,
  UserNameIcon,
  VertifyLink,
} from "./atom";
import { getAuthStatusTranslate } from "@/pages/profile/helper/getAuthStatusTranslate";
import { redirectToAuth } from "@/pages/profile/helper/redirectToAuth";
import {
  PictureMemberType,
  pictureMemberPrivilege,
} from "../../constants/picture-vip-info";
import { Space, ToolTip } from "task-eva-ui";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { DesktopRechargeTab } from "../../constants/picture-balance-info";

export function PictureUserInfoBar() {
  const { t } = useTranslation("topup");
  const {
    userInfo,
    isSubAccount,
    isStudentValid,
    isPersonal,
    studentCertifyInfo,
    currencySymbol,
    userDesktopInfo,
  } = useGlobalStore();
  const authStatusTranslate = getAuthStatusTranslate(
    userInfo?.authStatus || 0,
    isStudentValid,
    isPersonal
  );
  const info = PictureMemberType.get(userInfo?.pictureLever || 0);
  const location = useLocation();
  const isDesktopTab = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const activeNameValue = params.get("activeName");
    return activeNameValue === DesktopRechargeTab.Desktop;
  }, [location]);

  return (
    <MemberSystemWrapper>
      <Space gap={6} align={"center"}>
        <UserNameIcon>{userInfo?.userName?.[0].toUpperCase()}</UserNameIcon>
        <UserName>{userInfo?.userName}</UserName>
        {!isSubAccount && authStatusTranslate && (
          <VertifyLink
            onClick={() => {
              redirectToAuth(userInfo, studentCertifyInfo?.studentBlock);
            }}
          >
            {authStatusTranslate}
          </VertifyLink>
        )}
      </Space>
      {isDesktopTab && (
        <>
          <BalanceTextContent>
            <BalanceText>
              <p>{t("topUp_current_desktop")}</p>
              <ToolTip
                content={`${currencySymbol}${userDesktopInfo?.availableAmount}`}
                trigger="hover"
              >
                <span className="symbol">{currencySymbol}</span>
                <span className="credit">
                  {userDesktopInfo?.availableAmount}
                </span>
              </ToolTip>
            </BalanceText>
            {!isStudentValid && (
              <BalanceText className="border-left">
                <p>{t("accumulative_recharge_desktop")}</p>
                <ToolTip
                  content={`${currencySymbol}${userDesktopInfo?.cumulative}`}
                  trigger="hover"
                >
                  <span className="symbol">{currencySymbol}</span>
                  <span className="credit">{userDesktopInfo?.cumulative}</span>
                </ToolTip>
              </BalanceText>
            )}
          </BalanceTextContent>
        </>
      )}
      {!isDesktopTab && (
        <>
          <LevelCard>
            <img src={info?.bgImg} alt="" />
            <div>
              <span>{info?.text}</span>
              {userInfo?.pictureLever === PictureLever.Member && (
                <span>
                  &nbsp;
                  {dayjs(userInfo?.picMemberValidity).format("YYYY-MM-DD")}
                </span>
              )}
            </div>
          </LevelCard>
          <Privilege>
            <PrivilegeTitle>{t("picture_vip_privilege_title")}</PrivilegeTitle>
            <PrivilegeContent>
              {pictureMemberPrivilege.map((item) => {
                return (
                  <Space gap={10} align="center">
                    <div>
                      <p className="title">{item.title}</p>
                      <p className="sub-title">{item.subTitle}</p>
                    </div>
                  </Space>
                );
              })}
            </PrivilegeContent>
          </Privilege>
        </>
      )}
    </MemberSystemWrapper>
  );
}
